class EventHub {
  constructor() {
    this.eventCollection = {};
  }

  on(event, fn) {
    this._validateEvent(event);
    if (!this.eventCollection[event]) {
      this.eventCollection[event] = [];
    }
    this.eventCollection[event].push(fn);
  }

  off(event, fn) {
    this._validateEvent(event);
    this.eventCollection[event] = this.eventCollection[event].filter((oldFn) => oldFn !== fn);
  }

  _validateEvent(event) {
    const registeredEvents = ['sendAudio', 'sendText', 'sendFile', 'sendQuestion'];
    if (!registeredEvents.includes(event)) {
      throw new Error('Unkown Event');
    }
  }

  emit(event, ...params) {
    const triggerdFunctions = this.eventCollection[event];
    triggerdFunctions && triggerdFunctions.forEach((fn) => fn.apply(null, params));
  }
}

export default EventHub;
